import { IdIcon } from "../generic/icon/IdIcon";
export var MapPromotionIcon = new Map([
    [-1, IdIcon.LeagueDemotedIcn],
    [1, IdIcon.LeaguePromotedIcn],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/MapPromotionIcon.ts
// module id = 2798
// module chunks = 3